import React, { useRef, useState } from "react";
import PageTitleBanner from "./Common/PageTitleBanner";
import Swal from "sweetalert2";
import { NOTEBOOKURL } from "../Config";
import axios from "axios";

const DistributerEnquiry = () => {
  const [isSubmit, setIsSubmit] = useState(false);
  const fileInputRef = useRef(null);

  const [validMail, setValidMail] = useState(false);
  const [formData, setFormData] = useState({
    UserName: {
      textValue: "",
      required: true,
    },
    PhoneNumber: {
      textValue: "",
      required: true,
      valid: false,
    },
    EmailID: {
      textValue: "",
      required: false,
      valid: true,
    },
    CompanyName: {
      textValue: "",
      required: false,
    },
    TotalExperience: {
      textValue: "",
      required: false,
    },
    Message: {
      textValue: "",
      required: true,
    },
    Atachment: {
      textValue: "",
      valid: true,
      required: false,
    },
  });

  const handleInputChange = (e) => {
    let lastInputString = e.target.value[e.target.value.length - 1];
    console.log(lastInputString);
    if (e.target.name == "PhoneNumber") {
      if (
        e.target.value == "" ||
        (lastInputString.charCodeAt() >= 48 &&
          lastInputString.charCodeAt() <= 57)
      ) {
        setFormData({
          ...formData,
          [e.target.name]: {
            ...formData[e.target.name],
            textValue: e.target.value,
            valid: e.target.value.length === 10 ? true : false,
          },
        });
      } else {
        return;
      }
      return;
    }
    if (e.target.name === "EmailID") {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (emailRegex.test(e.target.value)) {
        setValidMail(true);
      } else {
        setValidMail(false);
      }
    }
    setFormData({
      ...formData,
      [e.target.name]: {
        ...formData[e.target.name],
        textValue: e.target.value,
      },
    });
  };
  const handleFileChange = (e) => {
    console.log(e.target.files[0], "e.target.value");

    if (
      ["jpg", "png", "jpeg", "pdf", "PDF"].includes(
        e.target.value.split(".")[e.target.value.split(".").length - 1]
      ) ||
      e.target.value === ""
    ) {
      setFormData({
        ...formData,
        [e.target.name]: {
          ...formData[e.target.name],
          textValue: e.target.files[0],
          valid: true,
        },
      });
    } else {
      setFormData({
        ...formData,
        [e.target.name]: {
          ...formData[e.target.name],
          textValue: "",
          valid: false,
        },
      });
    }
  };
  const handleSubmit = (e) => {
    debugger
    e.preventDefault();
    setIsSubmit(true);
    console.log(formData, "formData");
    let validForm = true;
    for (let key in formData) {
      if (formData[key].required) {
        if (!formData[key].textValue) {
          validForm = false;
        }

        if (!validForm) {
          return;
        }
      }
    }

    if (formData.PhoneNumber.textValue.length !== 10) {
      setFormData((prev) => {
        let updatedValue = {
          ...prev,
          PhoneNumber: {
            ...prev.PhoneNumber,
            valid: false,
          },
        };
        return updatedValue;
      });
      validForm = false;

      if (validForm == false) {
        return;
      }
    }
    if (formData.Atachment?.valid == false) {
      return;
    }
    // if (!validMail) {
    //   return;
    // }

    if (!validMail && formData.EmailID.textValue.length) {
      return;
    }
    if (formData.UserName.textValue.length <= 2) {
      return;
    }
    console.log(formData);

    const form = new FormData();
    form.append("Name", formData?.UserName?.textValue);
    form.append("MobileNo", formData?.PhoneNumber?.textValue);
    form.append("EmailID", formData?.EmailID?.textValue);
    form.append("CompanyName", formData?.CompanyName?.textValue);
    form.append("BusinessExperience", formData?.TotalExperience?.textValue);
    form.append("Description", formData?.Message?.textValue);
    form.append("Attachment", formData?.Atachment?.textValue);

    const config = { headers: { "Content-Type": "multipart/form-data" } };
    axios.post(
      `${NOTEBOOKURL}DistributorEnquiry/SetDistributorEnquiry`,
      form,
      config
    ).then((result) => {
      console.log(result, "result");
      if (result.data.status === 1) {
        Swal.fire({
          title: "Submited Successfully",
          icon: "success",
          timer: 1500,
        });
        setFormData({
          UserName: {
            textValue: "",
            required: true,
          },
          PhoneNumber: {
            textValue: "",
            required: true,
            valid: false,
          },
          EmailID: {
            textValue: "",
            required: false,
          },
          CompanyName: {
            textValue: "",
            required: false,
          },
          TotalExperience: {
            textValue: "",
            required: false,
          },
          Message: {
            textValue: "",
            required: true,
          },
          Atachment: {
            textValue: "",
            valid: true,
            required: false,
          },
        });
        handleClearButtonClick()
        setValidMail(true);
        setIsSubmit(false);

      }
    })



  };
  const handleClearButtonClick = () => {

    if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }
  };
  return (
    <>
      <PageTitleBanner title={"Distributer Enquiry"} />
      <div className="site-content">
        <div className="container">
          <div style={{ margin: "50px 0px" }} className="row">
            <div className="col-sm-12">
              <div className="fp-section-title clearfix custom-title ">
                <h2>Distributer Enquiry Form</h2>
              </div>
              <div className="fp-form fp-form-3  paddtop40">
                <form onSubmit={handleSubmit} method="post" id="contact-form">

                  <div className="row">

                    <div className="col-lg-12">
                      <div className="col-sm-4">
                        <div className="form-group field">
                          <input
                            name="UserName"
                            value={formData.UserName.textValue}
                            onChange={handleInputChange}
                            placeholder="Your Name"
                            type="text"
                          />
                          {isSubmit &&
                            formData.UserName.textValue.length <= 2 && (
                              <span style={{ color: "red" }}>
                                Please Enter Name
                              </span>
                            )}
                        </div>
                      </div>
                      <div className="col-sm-4">
                        <div className="form-group field">
                          <input
                            name="PhoneNumber"
                            maxLength={10}
                            value={formData.PhoneNumber.textValue}
                            onChange={handleInputChange}
                            placeholder="Phone"
                            type="text"
                          />
                          {isSubmit && !formData.PhoneNumber.valid && (
                            <span style={{ color: "red" }}>
                              Please Enter Phone Number
                            </span>
                          )}
                        </div>
                      </div>
                      <div className="col-sm-4">
                        <div className="form-group field">
                          <input
                            name="EmailID"
                            value={formData.EmailID.textValue}
                            onChange={handleInputChange}
                            placeholder="Your Email"
                            type="text"
                          />
                          {isSubmit && (!validMail && (formData.EmailID.textValue.length != 0 && formData.EmailID.textValue.length > 0)) && (
                            <span style={{ color: "red" }}>
                              Please Enter Valid Email
                            </span>
                          )}
                        </div>
                      </div>
                    </div>

                    <div className="col-lg-12">
                    <div className="col-sm-4">
                      <div className="form-group field">
                        <input
                          name="CompanyName"
                          value={formData.CompanyName.textValue}
                          onChange={handleInputChange}
                          placeholder="Your Company Name"
                          type="text"
                        />
                      </div>
                    </div>
                    <div className="col-sm-4">
                      <div className="form-group field">
                        <input
                          name="TotalExperience"
                          value={formData.TotalExperience.textValue}
                          onChange={handleInputChange}
                          placeholder="Your Total Experience"
                          type="text"
                        />
                      </div>
                    </div>
                    <div className="col-sm-4">
                      <div className="form-group">
                        <input
                          ref={fileInputRef}
                          type="file"
                          name="Atachment"
                          accept="image/jpeg, image/png, image/jpg , .pdf , .PDF"
                          onChange={handleFileChange}
                        />
                        {!formData.Atachment.valid && (
                          <span style={{ color: "red" }}>
                            Please Enter Valid File
                          </span>
                        )}
                      </div>
                    </div>
                    </div>

                    <div className="col-lg-12">
                    <div className="col-sm-12">
                      <div className="form-group">
                        <textarea
                          name="Message"
                          value={formData.Message.textValue}
                          onChange={handleInputChange}
                          placeholder="Message"
                          maxLength={150}
                        />
                        {isSubmit && !formData.Message.textValue.length && (
                          <span style={{ color: "red" }}>
                            Please Enter Your Requirement
                          </span>
                        )}
                      </div>
                    </div>
                    </div>

                    <div className="col-lg-12">
                    <div className="col-sm-2 submit text-center paddtop30">
                      <input
                        type="submit"
                        defaultValue="Submit Now"
                        className="fh-btn"
                      />
                    </div>
                    </div>
                    
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default DistributerEnquiry;
